import { Injectable } from '@angular/core';
import {
  FormBase,
  TextBox,
  CheckBox,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { EnrollEftEpayService } from '../enroll-eft-epay/enroll-eft-epay.service';
import { Constants } from '@models/constants';
import { FormBaseInputsService } from '@services/common/form-base-inputs.service';

@Injectable({
  providedIn: 'root',
})
export class NewPaymentService {
  constructor(private enrollEftEpayService: EnrollEftEpayService, 
    private fbInputService: FormBaseInputsService,
    private acmicService:AcmicService) {}

  isValidAddress(policyId): boolean {
    return (policyId.length !== 10);   
  }
  getInputsForAchGuest(policyId) {
    const inputs = this.getInputs(policyId);
    return inputs.filter(input => input.key !== 'newPayment_storeInformation');
  }
  getInputsForBilling() {
    const inputs: FormBase<any>[] = [
      this.enrollEftEpayService.getAccountNameField(
        'newPayment_accountName',
        'ACCOUNT_HOLDERS_NAME',
        'BANK_ACCOUNT_HOLDER_NAME_VALIDATION',
        'Type name'
      ),
      this.enrollEftEpayService.getRoutingNumberField(
        'newPayment_routingNumber',
        'BANK_ROUTING_NUMBER',
        'BANK_ROUTING_NUMBER_VALIDATION',
        'Type number'
      ),
      this.enrollEftEpayService.getAccountNumberField(
        'newPayment_accountNumber',
        'ACCOUNT_NUMBER',
        'BANK_ACCOUNT_NUMBER_VALIDATION',
        'Type number'
      ),
      this.enrollEftEpayService.getConfirmAccountNumberField(
        'newPayment_confirmAccountNumber',
        'CONFIRM_BANK_ACCOUNT_NUMBER',
        'BANK_ACCOUNT_NUMBER_VALIDATION',
        'Type number'
      ),new CheckBox({
        key: 'newPayment_storeInformation',
        inputType: 'checkbox',
        label: 'STORE_INFORMATION',
        required: false,
        type: 'checkbox',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'newPayment_checkNumber',
        label: 'CHECK_NUMBER_OPTIONAL',
        required: false,
        maxLength: 5,
        maximumLength: 5,
        type: 'text',
        validationMessageError: 'Please enter valid check number',
        placeholder:this.acmicService.isACMIC()? 'Type number' :''
      }),
    ];
    return inputs;
  }
  getInputs(policyId) {
    const inputs: FormBase<any>[] = [
      this.enrollEftEpayService.getAccountNameField(
        'newPayment_accountName',
        'ACCOUNT_HOLDERS_NAME',
        'BANK_ACCOUNT_HOLDER_NAME_VALIDATION'
      ),
      this.enrollEftEpayService.getRoutingNumberField(
        'newPayment_routingNumber',
        'BANK_ROUTING_NUMBER',
        'BANK_ROUTING_NUMBER_VALIDATION'
      ),
      this.enrollEftEpayService.getAccountNumberField(
        'newPayment_accountNumber',
        'ACCOUNT_NUMBER',
        'BANK_ACCOUNT_NUMBER_VALIDATION'
      ),
      this.enrollEftEpayService.getConfirmAccountNumberField(
        'newPayment_confirmAccountNumber',
        'CONFIRM_BANK_ACCOUNT_NUMBER',
        'BANK_ACCOUNT_NUMBER_VALIDATION'
      ),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'address',
        key: 'newPayment_mailingAddress',
        label: 'ADDRESS',
        required: this.isValidAddress(policyId),
        type: 'text',
        validationMessageError: 'VALID_ADDRESS',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'newPayment_aptNumber',
        label: 'Apt / Suite / Other',
        required: false,
        type: 'text',
      }),
      this.fbInputService.getInputTextBox('poBoxNumber','newPayment_poBoxAddress', 'PO Box number', 'text'),
      this.fbInputService.getInputTextBox('zipcode','newPayment_zipCode', 'ZIP code', 'text'),
      this.fbInputService.getInputTextBox('text','newPayment_city_state', 'City, State', 'text'),
      this.fbInputService.getInputTextBox('zipcode','newPayment_PO_zipCode', 'ZIP code', 'text'),
      this.fbInputService.getInputTextBox('text','newPayment_PO_city_state', 'City, State', 'text'),
      this.fbInputService.getInputSelectBox('select', 'newPayment_multipleCities', 'City', 'select'),
      this.fbInputService.getInputTextBox('text','newPayment_state', 'State', 'text'),
      this.fbInputService.getInputSelectBox('select', 'newPayment_PO_multipleCities', 'City', 'select'),
      this.fbInputService.getInputTextBox('text','newPayment_PO_state', 'State', 'text'),      
      new CheckBox({
        key: 'newPayment_storeInformation',
        inputType: 'checkbox',
        label: 'STORE_INFORMATION',
        required: false,
        type: 'checkbox',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'newPayment_checkNumber',
        label: 'CHECK_NUMBER_OPTIONAL',
        required: false,
        maxLength: 5,
        maximumLength: 5,
        type: 'text',
        validationMessageError: 'Please enter valid check number',
      }),
    ];
    return inputs;
  }
}
